import {
  Component,
  OnInit,
  Input,
  OnChanges,
  forwardRef,
  SimpleChanges,
  EventEmitter,
  Output,
  ContentChild,
  TemplateRef,
} from '@angular/core';

import {
  ControlValueAccessor,
  FormControl,
  FormsModule,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
} from '@angular/forms';

import { RxSelectOptionDirective } from './rx-select-option';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'rx-select',
  templateUrl: './rx-select.component.html',
  styleUrls: ['./rx-select.component.scss'],
  imports: [CommonModule, MatSelectModule, FormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RxSelectComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => RxSelectComponent),
      multi: true,
    },
  ],
})
export class RxSelectComponent implements ControlValueAccessor, Validator {
  @Input()
  public items: any[];

  @Input()
  public value: any;

  @Input()
  public disable: boolean;

  @Input()
  public bindLabel = 'text';

  @Input()
  public bindValue = 'value';

  @Input()
  public name = 'item';

  @Input()
  public placeholder = '';

  @Output()
  public valueChange: EventEmitter<any> = new EventEmitter();

  @Input()
  public panelClass = '';

  @Input()
  get selectedValue() {
    return this._selectedValue;
  }
  set selectedValue(value) {
    if (value !== this._selectedValue) {
      this._selectedValue = value;
      this.value = value;
    }
  }

  @Output()
  public selectedValueChange: EventEmitter<any> = new EventEmitter();

  @Input() optionTemplate: TemplateRef<{ item: any }>;
  @ContentChild(RxSelectOptionDirective, { static: true, read: TemplateRef })
  set optionView(value: RxSelectOptionDirective) {
    this.optionTemplate = <any>value;
  }

  // public optionTemplate: RxSelectOptionDirective;
  public fullObject: any;

  public control: FormControl;

  private _selectedValue: any;

  public onChange = (value: string) => {};
  public onTouched = () => {};

  constructor() {}

  public onModelChanged(event) {
    this.fullObject = this.items.find((item) => item[this.bindValue] === event);

    this.value = event;
    this.selectedValueChange.emit(event);
    this.onChange(event);
  }

  // Register for change
  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  // Register for touch/click
  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  // Update the model and changes
  public writeValue(value: any): void {
    if (this.value !== value) {
      if (value && typeof value === 'object' && !value.value) {
        const varient = this.items.find((item) => item[this.bindLabel] === value[this.bindLabel]);
        if (varient) {
          this.fullObject = varient;
          this.value = varient.value;
        }
      } else {
        this.value = value;
        this.fullObject = this.items.find((item) => item[this.bindValue] === value);
      }
      this.onChange(this.value);
    }
  }

  public isValid(): boolean {
    return this.control && !this.control.pending && !this.control.errors && !this.control.invalid;
  }

  // validate
  public validate(control: FormControl): any {
    this.control = control;
    return control.valid ? null : control.errors;
  }
}
